import { openDB, type DBSchema } from 'idb';
import type { PaperSize } from '@/lib/pdf/pdf-constants';

type PDFFormat = 'list' | 'annual' | 'monthly-calendar' | 'monthly-list' | 'saddle-stitch';

export interface CalendarPreset {
  id: string;
  name: string;
  selectedFormat: PDFFormat;
  paperSize: PaperSize;
  selectedYear: number;
  selectedImages: Record<string, string>;
  createdAt: number;
  updatedAt: number;
}

interface CalendarPresetsDB extends DBSchema {
  presets: {
    key: string;
    value: CalendarPreset;
    indexes: { 'by-updated': number };
  };
}

function getDB() {
  return openDB<CalendarPresetsDB>('srac-calendar-presets', 1, {
    upgrade(db) {
      const store = db.createObjectStore('presets', { keyPath: 'id' });
      store.createIndex('by-updated', 'updatedAt');
    },
  });
}

export async function getAllPresets(): Promise<CalendarPreset[]> {
  const db = await getDB();
  const all = await db.getAllFromIndex('presets', 'by-updated');
  return all.reverse(); // most recent first
}

export async function getPreset(id: string): Promise<CalendarPreset | undefined> {
  const db = await getDB();
  return db.get('presets', id);
}

export async function savePreset(preset: CalendarPreset): Promise<CalendarPreset> {
  const db = await getDB();
  await db.put('presets', preset);
  return preset;
}

export async function deletePreset(id: string): Promise<void> {
  const db = await getDB();
  await db.delete('presets', id);
}
